commusoftCommon.service('fiveHundredError', function(){
    this.errorMessage = {};
    this.setData = function setData(fullObject) {
        this.errorMessage = fullObject;
    }
    this.getData = function getData(){
        return this.errorMessage;
    }
});